import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/boys.svg'
import _imports_1 from '@/assets/images/girls.svg'


const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }
const _hoisted_2 = { class: "custom-padding-30" }
const _hoisted_3 = {
  style: {"margin":"-5px -9px -27px -16px"},
  class: "pb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 pb-4" }, [
        _createElementVNode("h3", { class: "mb-0 fw-semibold" }, "Students Overview"),
        _createElementVNode("div", {
          class: "dropdown select-dropdown without-border position-relative",
          style: {"right":"-5px"}
        }, [
          _createElementVNode("button", {
            class: "dropdown-toggle bg-transparent border text-body rounded-2",
            style: {"padding-right":"20px"},
            role: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, " Last Month "),
          _createElementVNode("ul", {
            class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3",
            style: {}
          }, [
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Today ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Month ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Year ")
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "bar",
              height: "291",
              options: _ctx.studentsOverview,
              series: _ctx.students
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createStaticVNode("<div><div class=\"d-flex gap-2 align-items-center\"><div class=\"d-flex\"><div class=\"text-center rounded-1\" style=\"background-color:#daebff;width:42px;height:42px;line-height:42px;\"><img src=\"" + _imports_0 + "\" alt=\"boys\"></div><div class=\"ms-2\"><span class=\"d-block\">Boys</span><h3 class=\"fs-20 fw-semibold mb-0\">980</h3></div></div><div class=\"d-flex ms-5\"><div class=\"text-center rounded-1\" style=\"background-color:#ffe8d4;width:42px;height:42px;line-height:42px;\"><img src=\"" + _imports_1 + "\" alt=\"boys\"></div><div class=\"ms-2\"><span class=\"d-block\">Girls</span><h3 class=\"fs-20 fw-semibold mb-0\">675</h3></div></div></div></div>", 1))
    ])
  ]))
}